import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LayoutComponent } from '@bizzdesign/feature-layout';

@Component({
  imports: [LayoutComponent],
  selector: 'bd-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
